module.exports = __webpack_public_path__ + "static/ganzheitlich-7e890b9cccede127a2f296ecdd3d9fdd.jpg";